/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas() {
        return axiosJwt.get(`${api}/fornecedores/atualizacoescadastrais`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt.get(`${api}/fornecedores/atualizacoescadastrais/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    reprovar(atualizacaoCadastral) {
        return axiosJwt.post(`${api}/fornecedores/atualizacoescadastrais/${atualizacaoCadastral.atualizacaoCadastralId}/reprovar`,
                atualizacaoCadastral)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    aprovar(atualizacaoCadastralId) {
        return axiosJwt.post(`${api}/fornecedores/atualizacoescadastrais/${atualizacaoCadastralId}/aprovar`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }
}
